<style lang="scss" scoped>
  @import "details";
  .search-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-form-item{
      margin-bottom:0;
    }
    .el-input{
      width:130px;
    }
  }
  .download{
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
</style>

<template>
  <div class="user-details">
    <section class="container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/user' }">用户中心</el-breadcrumb-item>
        <el-breadcrumb-item><router-link to="/user/primer">引物合成订单</router-link></el-breadcrumb-item>
        <el-breadcrumb-item>引物合成订单详情</el-breadcrumb-item>
      </el-breadcrumb>
      <h3 class="title">引物合成订单反应结果综合查询</h3>
<!--      <p class="text-gray9">测序结果为您保存6个月，超期将无法下载，请您及时下载并备份测序结果</p>-->
      <div class="search-top mt20">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="下单时间：">
            <el-date-picker
              v-model="searchForm.date"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始时间"
              end-placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单号：">
            <el-input v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="引物名称：">
            <el-input v-model="searchForm.primerName" placeholder="请输入引物名称"></el-input>
          </el-form-item>
          <el-form-item label="引物序列：">
            <el-input v-model="searchForm.sequence" placeholder="请输入引物序列"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getReaction">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        border
        class="mt20"
        :data="reactionLists"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="value.no"
          label="订单编号">
        </el-table-column>
        <el-table-column
          prop="value.no"
          label="引物编号">
        </el-table-column>
        <el-table-column
          prop="value.primer.name"
          label="引物名称">
        </el-table-column>
        <el-table-column
          prop="value.sequence"
          label="引物序列">
        </el-table-column>
        <el-table-column
          prop="value.reactionStatusName"
          label="碱基数">
        </el-table-column>
        <el-table-column
          prop="value.purificationWay"
          label="纯度级别">
        </el-table-column>
        <el-table-column
          prop="value.odNum"
          label="OD/管">
        </el-table-column>
        <el-table-column
          prop="value.fzNum"
          label="分装管数">
        </el-table-column>
        <el-table-column
          prop="value.modify5"
          label="5端修饰">
        </el-table-column>
        <el-table-column
          prop="value.modify3"
          label="3端修饰">
        </el-table-column>
        <el-table-column
          prop="value.modifyMid"
          label="中间修饰">
        </el-table-column>
        <el-table-column
          prop="value.remark"
          label="备注">
        </el-table-column>
        <el-table-column
          prop="date"
          label="下单时间">
          <template slot-scope="scope">{{scope.row.value.createTime | rTime}}</template>
        </el-table-column>
      </el-table>
      <div class="page tr">
        <el-pagination
          layout="total, sizes, prev, pager, next"
          :total="total"
          :page-sizes="[10, 20, 50, 100, 200, 500]"
          @size-change="changeSize"
          @current-change="changePage">
        </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
  import { sequencingWorkOrders, sangerWorderDoc } from '@/services/api.index'
  export default {
  data () {
    return {
      searchForm: {
        primerName: '',
        sequence:'',
        orderNo: '',
        date: null
      },
      reactionLists: [],
      effectTable: [],
      total: 0,
      page: 0,
      size: 10,
      multipleSelection: []
    }
  },
  created () {
    this.getReaction()
  },
  methods: {
    // 订单包含反应信息
    getReaction () {
      let { primerName,sequence, orderNo, date } = this.searchForm
      date = date || ['', '']
      const customerId = this.baseMethods.getLocalObj('memberInfo').id
      sequencingWorkOrders(this.page, this.size, date[0], date[1], orderNo, primerName,sequence, customerId).then(res => {
        this.reactionLists = res.data.list
        // this.reactionTotal = res.data.totalCount
        this.total = res.data.totalCount
      })
    },
    // 反应信息多选
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    changePage (value) {
      this.page = value - 1
      this.getReaction()
    },
    changeSize (value) {
      this.size = value
      this.getReaction()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/primer_search.vue